import { subscribe, getState, setActiveTab } from '../state/store.js';
import { renderStatsTab } from './stats.js';
import { renderCalendarTab } from './calendar.js';

const tabNav = document.getElementById('tabNav');
const tabButtons = document.querySelectorAll('.tab-btn[data-tab]');
const tabPanels = document.querySelectorAll('[data-tab-panel]');

const renderActiveTab = (state) => {
  tabButtons.forEach((btn) => {
    btn.classList.toggle('active', btn.dataset.tab === state.activeTab);
  });
  tabPanels.forEach((panel) => {
    panel.hidden = panel.dataset.tabPanel !== state.activeTab;
  });
  document.body.dataset.activeTab = state.activeTab;
  if (state.activeTab === 'stats') renderStatsTab();
  if (state.activeTab === 'calendar') renderCalendarTab();
};

export const initTabs = () => {
  tabNav?.addEventListener('click', (event) => {
    const btn = event.target.closest('.tab-btn[data-tab]');
    if (!btn) return;
    setActiveTab(btn.dataset.tab);
  });

  subscribe(renderActiveTab);
  renderActiveTab(getState());
};
